module.exports = __webpack_public_path__ + "img/Logo_scienotransparents.42b0b2da.png";